import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Survey, SurveyAnswer } from 'app/entities/nps-survey';
import { AlertService } from 'app/services/alert.service';
import { LocalStorageService } from 'app/services/local-storage.service';
import { NpsService } from 'app/services/nps.service';
import { ReferralDialogComponent } from '../referral-dialog/referral-dialog.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-nps-survey',
  templateUrl: './nps-survey.component.html',
  styleUrls: ['./nps-survey.component.scss']
})
export class NpsSurveyComponent implements OnInit, OnDestroy {

    // Pesquisa atual sendo exibida (primeira da fila)
    elegibleSurvey?: Survey
    // Fila de pesquisas pendentes
    surveyQueue: Survey[] = []
    // Pontuações possíveis para NPS
    scores = [1,2,3,4,5,6,7,8,9,10]
    npsForm: FormGroup
    expanded = false
    chipsQuestion = ""
    answers: SurveyAnswer[] = []
    answerType: number = 0
    shown = false
    loading = false
    // Flag para exibir o diálogo de indicação ao final do fluxo, caso qualquer resposta seja promotora
    private shouldShowReferral: boolean = false
    
    // Controle de inscrições para evitar memory leaks
    private subscriptions: Subscription[] = []

    constructor(
        private npsService: NpsService,
        private _formBuilder: FormBuilder,
        private _alertService: AlertService,
        private _localService: LocalStorageService,
        private _matDialog: MatDialog,
    ) {

        this.npsForm = this._formBuilder.group({
            score: [null, [Validators.required]],
            answers: [[], [Validators.required]],
            message: [null],
        });

    }

    otherSelectedValidator(){
        this.npsForm.controls.message.clearValidators()
        const selectedAnswers = this.npsForm?.controls?.answers.value;

        const otherSelected = this.answers.filter(asw=>{
            return selectedAnswers.includes(asw.id) && asw.answer=="Outro"
        })

        console.log(otherSelected);
        
    
        // If the condition is met, the dependentControl is required
        if (otherSelected.length>0) {
            this.npsForm.controls.message.setValidators(Validators.required)
        }

        this.npsForm.controls.message.updateValueAndValidity()
      
    }

  ngOnInit(): void {
    // Inscrever-se nas mudanças na fila de pesquisas
    const queueSubscription = this.npsService.surveyQueue$.subscribe(queue => {
      this.surveyQueue = queue;
      this.updateCurrentSurvey();
    });
    this.subscriptions.push(queueSubscription);
    
    // Carregar pesquisas elegíveis
    this.loadEligibleSurveys();
  }
  
  /**
   * Carrega as pesquisas elegíveis do servidor
   */
  loadEligibleSurveys(): void {
    const surveysSubscription = this.npsService.loadSurveysIfNeeded().subscribe(surveys => {
      if (surveys && surveys.length > 0) {
        this.updateCurrentSurvey();
      }
    });
    this.subscriptions.push(surveysSubscription);
  }
  
  /**
   * Atualiza a pesquisa atual com base na fila
   */
  updateCurrentSurvey(): void {
    const nextSurvey = this.npsService.getNextSurvey();
    if (nextSurvey) {
      this.elegibleSurvey = nextSurvey;
      this.resetForm();
      this.showExpandedIfWeCan();
    } else {
      this.elegibleSurvey = undefined;
    }
  }
  
  /**
   * Reseta o formulário para uma nova pesquisa
   */
  resetForm(): void {
    this.npsForm.reset();
    this.answers = [];
    this.shown = false;
    this.chipsQuestion = "";
    this.answerType = 0;
  }

  showExpandedIfWeCan(){
    let surveyInCoolDown = this._localService.getItem('nps-survey-cooldown')

    if(!surveyInCoolDown){
        this.expanded = true
    }


  }

  toggleVisibility(){
    this.expanded = !this.expanded
    if(!this.expanded){
        this._localService.setItem('nps-survey-cooldown',true,60*3)
    }
  }

  toggleChip(answer:number) {
    const chipsControl = this.npsForm.controls.answers;
    const value = chipsControl.value;

    if (value.includes(answer)) {
      // If the option is already selected, remove it
      const index = value.indexOf(answer);
      if (index >= 0) {
        value.splice(index, 1);
      }
    } else {
      // If the option is not selected, add it
      value.push(answer);
    }

    chipsControl.setValue(value);

    this.otherSelectedValidator()
    
  }

  getAnswers(score){

    this.shown = true

    // set the score
    this.npsForm.controls.score.setValue(score)

    
    if(!score){
        this.answers = [];
    }

    var newAnswerType = 0
    
    if(score > 6 && score < 9){ // neutral answers
        newAnswerType = 2;
    }else if(score > 8){ // promother answers
        newAnswerType = 3
    }else{// detractor answers
        newAnswerType = 1
    }

    if(this.answerType != newAnswerType){ // type changed!

        // reset the answers
        this.npsForm.controls.answers.setValue([])
        
        this.answerType = newAnswerType
        if(this.answerType == 2){ // neutral answers
            this.answers = this.elegibleSurvey!.neutralAnswers
            this.chipsQuestion = this.elegibleSurvey!.neutralQuestion
        }else if(this.answerType == 3){ // return promother answers
            this.answers = this.elegibleSurvey!.promoterAnswers
            this.chipsQuestion = this.elegibleSurvey!.promoterQuestion
        }else if(this.answerType == 1){// return detractor answers
            this.answers = this.elegibleSurvey!.detractorAnswers
            this.chipsQuestion = this.elegibleSurvey!.detractorQuestion
        }
    }

  }

  enviar(){
    if(!this.npsForm.valid){
        return
    }

    this.loading = true
    const data = this.npsForm.value
    const currentSurveyId = this.elegibleSurvey?.id;
    
    this.npsService.submitSurvey(currentSurveyId, data).subscribe(res=>{
      this.loading = false
      
      // Remover a pesquisa atual da fila
      if (currentSurveyId) {
        this.npsService.removeSurveyFromQueue(currentSurveyId);
      }
      
      // Se a resposta atual for promotora, marcar para exibir convite ao final
      if (this.npsForm.controls.score.value >= 9) {
        this.shouldShowReferral = true;
      }

      // Verificar se ainda há pesquisas na fila
      const hasMoreSurveys = this.npsService.hasSurveysInQueue();
      if (hasMoreSurveys) {
        // Atualizar para a próxima pesquisa na fila
        this.updateCurrentSurvey();
        this._alertService.success("Obrigado por responder nossa pesquisa! Temos mais uma pesquisa para você.");
      } else {
        // Não há mais pesquisas, fechar o componente
        this.expanded = false;
        this.shown = false;
        this._localService.setItem('nps-survey-cooldown', true, 60*60*24*7);
        this._alertService.success("Obrigado por responder nossa pesquisa! Vamos trabalhar para melhorar a Orca de acordo com as suas necessidades.");
        
        // Mostrar diálogo de indicação apenas ao finalizar a última pesquisa
        if (this.shouldShowReferral) {
          this.openReferralDialog();
          this.shouldShowReferral = false; // reset flag
        }
      }
      
    }, err=>{
      this.loading = false;
      this._alertService.error("Erro ao enviar pesquisa");
    });
  }

  openReferralDialog() {
      let dialog = this._matDialog.open(ReferralDialogComponent, {
          panelClass: ['form-dialog'],
      });
  }
  
  /**
   * Limpa as inscrições ao destruir o componente
   */
  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
